<template>
  <div class="Resources">
    <div class="case-title">
      <div class="icon_title">
        <div>
          <img class="case-title_icon" src="@/assets/images/imgAll/icon_zypz_@2x.png" alt />
        </div>
        <div class="case-title_max">系统动态数据配置</div>
      </div>
    </div>
    <div class="tab_click">
      <div class="tabRound">
        <div :class="clickTab == 1 ? 'left' : 'right'" @click="getItme(1)">其他配置</div>
        <div :class="clickTab == 2 ? 'left' : 'right'" @click="getItme(2)">协议说明</div>
      </div>
      <div class="sw_gong" v-if="clickTab === 1">
        <img src="https://img.fanxinghuishou.cn/20230814/217830517.png" alt="" />
        <span style="font-size:22px;margin-left:5px;">小程序客服功能开关：</span>
        <el-switch v-model="swichType" @change="cgswich" active-text="" inactive-text="">
        </el-switch>
      </div>
      <div v-if="clickTab == 1 && swichType" class="input_phone">
        <LableTitle title='客服电话' num='1' :showTitle="true"></LableTitle>
        <div class="form-item">
          <div style="font-size:14px;margin-right:12px;color:#666">客服电话</div>
          <el-input placeholder="请输入客服电话" v-model="phone" size="small" clearable>
          </el-input>
        </div>
        <!-- <LableTitle title='客服微信号' num='2' :showTitle="false"></LableTitle>
        <div class="form-item">
          <div style="font-size:14px;margin-right:12px;color:#666">微信号</div>
          <el-input
            placeholder="请输入内容"
            v-model="wechatNum"
            size="small"
            clearable>
          </el-input>
        </div> -->
        <LableTitle title='客服微信二维码' num='2' :showTitleAgree="true"></LableTitle>
        <div class="form-item img">
          <div style="font-size:14px;margin-right:12px;color:#666;margin-bottom:20px">仅支持上传一张图片，大小不超过500k</div>
          <ElImgUpload key="QRCode" :exist-image="QRCode" @handleChange="handleChange" />
        </div>
        <div>
          <div class="complant">
            <img src="https://img.fanxinghuishou.cn/20230814/117184588.png" alt=""><span>投诉客服设置</span>
          </div>
          <div class="form-item">
            <div style="font-size:14px;margin-right:12px;color:#666">客服电话</div>
            <el-input placeholder="请输入投诉客服电话" v-model="complantphone" size="small" clearable>
            </el-input>
          </div>
        </div>
        <div style="padding-left:50px">
          <el-button @click="handerClose()" size="small" style="margin-top:20px">返回</el-button>
          <el-button @click="handerSure()" type="primary" size="small" style="margin-top:20px">提交</el-button>
        </div>

        <!-- <GlobalForm 
          :init-data="initData"
          :form-rules="formRules"
          :form-item-list="formItemList"
          @handleConfirm="handerClick"
          confirmBtnName="提交"
        >
        <el-button @click="handerClose()" slot="btnSlot" style="margin-top:100px">返回</el-button>
        </GlobalForm> -->
      </div>
      <div v-if="this.clickTab == 2">
        <ResourcesEditor></ResourcesEditor>
      </div>
    </div>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { http } from "../../../utils/request/newIndex"
import { formValidateMobileLandline } from "@/utils/form-validate";
import ElImgUpload from "@/components/global/components/elements/upload-element";
import ResourcesEditor from './component/ResourcesEditor'
import LableTitle from './component/label-title'
export default {
  components: { ResourcesEditor, LableTitle, ElImgUpload },
  data() {
    return {
      clickTab: "1",
      initData: {
        phone: "",
      },
      QRCode: "",
      phone: "",
      complantphone: "",
      wechatNum: "",
      swichType: false,
      formItemList: [{
        key: "phone",
        type: "input",
        labelName: "客服电话",
        placeholder: "请输入客服电话"
      }],
      updata: {
        "modifySysStaticConfigVo": []
      },
      formRules: {
        phone: [
          {
            required: true,
            validator: formValidateMobileLandline,
            trigger: "blur"
          }
        ],
      }
    };
  },
  created() {
    this.getItme(1)
  },
  methods: {
    getItme(index) {
      this.clickTab = index
      this.updata.modifySysStaticConfigVo = []
      if (index === 1) {
        const vo = {
          "keys": [],
          "module": 'website'
        }
        http.getConfig(vo).then(res => {
          if (res.code === 1) {
            console.log(res);
            this.swichType = res.data[0].sysValue === "00" ? false : true
            this.phone = res.data[1].sysValue || ""
            this.complantphone = res.data[3].sysValue || ""
            this.QRCode = res.data[2].sysValue || ""
            console.log(this.initData.phone)
            res.data.forEach((i, index) => {
              this.updata.modifySysStaticConfigVo.push({
                "key": i.sysKey,
                "value": i.sysValue,
              })
            })
            console.log(this.updata.modifySysStaticConfigVo, "this.updata.modifySysStaticConfigVo");
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    cgswich(e) {
      if (e) {
        console.log(e);
      } else {
        console.log(e);
      }
      this.handeSwitch()
    },
    //客服功能开关
    handeSwitch() {
      console.log(this.QRCode);
      this.updata.modifySysStaticConfigVo[0].value =this.swichType=== true ? "01" : "00"
      console.log(this.updata.modifySysStaticConfigVo);
      http.updateConfig(this.updata).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg)
        }
      })
    },
    //提交
    handerSure() {
      console.log(this.QRCode);
      this.updata.modifySysStaticConfigVo[0].value =this.swichType=== true ? "01" : "00"
      if(!this.phone){
        this.$message.error("请输入客服电话")
        return
      }
      if(!this.complantphone){
        this.$message.error("请输入投诉客服电话")
        return
      }
      if(!this.QRCode){
        this.$message.error("请上传客服微信二维码")
        return
      }
      this.updata.modifySysStaticConfigVo[1].value = this.phone
      this.updata.modifySysStaticConfigVo[3].value =this.complantphone
      this.updata.modifySysStaticConfigVo[2].value = this.QRCode 
      console.log(this.updata.modifySysStaticConfigVo);
      http.updateConfig(this.updata).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg)
        }
      })
    },
    // 返回
    handerClose() {
      this.$router.go(-1)
    },
    handleChange(e) {
      console.log(e);
      this.QRCode = e
    }
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.complant {
  margin: 40px 0 20px 0;
  display: flex;
  align-items: center;
}

.Resources {
  width: 100%;
  min-height: 800px;
  background: #ffffff;
  box-shadow: 0px 8px 31px 0px rgba(20, 49, 127, 0.08);
  border-radius: 20px;

  .tabRound {
    cursor: pointer;
    margin-bottom: 40px;
    width: 280px;
    height: 32px;
    background: #F9FBFD;
    border: 1px solid #C1D1FF;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 16px;
    display: flex;

    .left {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 34px;
      height: 32px;
      background: #0981FF;
      border-radius: 16px;
    }

    .right {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 34px;
      height: 32px;
      border-radius: 16px;
    }
  }

  .case-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .icon_title {
      display: flex;

      .case-title_icon {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

      .case-title_max {
        display: inline-block;
        width: 200px;
        height: 17px;
        font-size: 18px;
        font-family: FZLanTingHei-B-GBK;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
    }
  }

  .tab_click {
    padding: 20px 0 50px 50px;

    .input_phone {
      /deep/ .el-input {
        width: 340px;
      }
    }
  }

  .sw_gong {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .form-item {
    width: 460px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 50px;
    margin-bottom: 20px;
  }

  .form-item.img {
    display: block;
    justify-content: flex-start;
  }
}
</style>